var React = require('react');

function InputPlus (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"10","y":"15.5","width":"12","height":"1","fill":"#121212","key":0}),React.createElement("rect",{"x":"15.5","y":"22","width":"12","height":"1","transform":"rotate(-90 15.5 22)","fill":"#121212","key":1}),React.createElement("defs",{"key":2},React.createElement("linearGradient",{"id":"paint0_linear_107_304","x1":"16","y1":"0","x2":"16","y2":"32","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"stopColor":"#EEEEEE","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#D5D5D5","key":1})]))]);
}

InputPlus.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = InputPlus;

InputPlus.default = InputPlus;
